// extracted by mini-css-extract-plugin
module.exports = {"AppLogo":"AppLogo_AppLogo__2LJHM"};